import React from 'react';
import { Card } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { roleUrl } from '@/constants/urls';
import CardItem from '@/components/cards/CardItem';
import NameDescriptionCard from '@/components/cards/NameDescriptionCard';
import RoleToolsMenu from '../containers/RoleToolsMenu';
import { adminPermissionsCount } from '../helper';

const RoleCardItem = ({
  category,
  defaultRole,
  onCheckBoxClick,
  role,
  single,
  upward,
}) => (
  <CardItem className="aridhia-role-list-item" warning={defaultRole}>
    <NameDescriptionCard
      description={role.description}
      entity="role"
      link={roleUrl(role)}
      markdown
      name={role.name}
      onSelect={onCheckBoxClick ? () => onCheckBoxClick(role.code, category) : undefined}
      selected={role.selected}
      single={single}
      system={role.system}
      visibility={defaultRole ? 'default' : undefined}
    >
      <RoleToolsMenu
        category={category}
        iconSize="large"
        listItem
        role={role}
        upward={upward}
        url={roleUrl(role, '#')}
      />
    </NameDescriptionCard>
    <Card.Content extra>
      <FormattedMessage
        id="permissions.count"
        values={{ total: role.metrics.all_permissions, admin: adminPermissionsCount(role) }}
      />
    </Card.Content>
  </CardItem>
);

export default RoleCardItem;
